import { Popover, styled } from '@mui/material';
import { popoverClasses } from '@mui/material/Popover';

/**
 * Panel de la campana. Ancho fijo y cómodo en desktop, ancho completo en mobile, y ALTO
 * acotado: el scroll vive dentro de la lista, así la cabecera y el pie no se mueven.
 */
const StyledNotificationPanel = styled(Popover)(({ theme }) => ({
  [`& .${popoverClasses.paper}`]: {
    backgroundColor: theme.palette.surface.content,
    // Sin esto MUI pinta encima su gradiente de elevación y el panel se ve lavado.
    backgroundImage: 'none',
    border: `1px solid ${theme.palette.hairline.main}`,
    borderRadius: 16,
    boxShadow: theme.palette.shadow.card,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'min(76vh, 560px)',
    overflow: 'hidden',
    // 32px = el doble del `marginThreshold` del Popover: así queda centrado en mobile.
    width: `calc(100vw - ${theme.spacing(4)})`,
    [theme.breakpoints.up('sm')]: {
      width: 400
    }
  }
}));

export default StyledNotificationPanel;
